import getConfig from 'next/config';

import Monitor from './Monitor';

const { publicRuntimeConfig: config = {} } = getConfig();
const { enableSentry, sentryDSN, sentryConfig } = config;

// app-global singleton
const monitor = new Monitor();

if (enableSentry) monitor.install(sentryDSN, sentryConfig);

export default monitor;
